import React, { ComponentType } from "react"
import { NodeProps } from "reactflow"
import { Chip, Grid, Typography } from "@material-ui/core"

import { BlockNodeData } from "@/protocols/chatBotFlow"

import useChatBotFlowConstructorStore from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowConstructorStore"
import useChatBotFlowBlockDetails from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowBlockDetails"

import BaseBlock from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BaseBlock"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionGroup from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionGroup"
import AfterActionConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/AfterActionConditionSection"
import ContrastChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/ContrastChip"
import WithoutAICreditsConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIConditionBlock/WithoutAICreditsConditionSection"

import CustomFieldSelectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/CustomFieldFillBlock/CustomFieldSelectionEditor"
import NoFieldFilledConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/CustomFieldFillBlock/NoFieldFilledConditionSection"

import { colors } from "@/styles/colors"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/CustomFieldFillBlock/styles"

const CustomFieldFillBlock: ComponentType<NodeProps<BlockNodeData>> = (node) => {
	const chatBotFlowConstructorStore = useChatBotFlowConstructorStore()
	const chatBotFlowBlockDetails = useChatBotFlowBlockDetails({ chatBotFlowBlockId: node.data.chatBotFlowBlockId })

	const classes = useStyles()

	const selectedFields = chatBotFlowBlockDetails.content?.customFieldFillData?.fields ?? []

	const customFieldOptions = chatBotFlowConstructorStore.constructionResources?.conditionOptions?.customFields ?? []
	const customFieldIdToDisplayName = new Map(customFieldOptions.map(option => [option.id, option.name]))

	const resolveFieldDisplayName = (field: { customFieldId: number; variable: string }): string => {
		return customFieldIdToDisplayName.get(field.customFieldId) ?? field.variable
	}

	return (
		<BaseBlock
			node={node}
		>
			<BlockBodySectionGroup>
				<BlockBodySection
					fullWidth
				>
					<CustomFieldSelectionEditor
						chatBotFlowBlockContent={chatBotFlowBlockDetails.content}
						onSave={content => chatBotFlowBlockDetails.changeContent(content)}
					>
						<Grid className={classes.fieldsSummaryCard}>
							<Typography className={classes.fieldsSummaryLabel}>
								Campos que o bloco pode preencher:
							</Typography>

							<Grid className={classes.fieldsSummaryChips}>
								{selectedFields.length > 0 ? (
									selectedFields.map(field => (
										<Chip
											key={field.customFieldId}
											label={resolveFieldDisplayName(field)}
											size="small"
											className={classes.fieldChip}
											style={{ backgroundColor: colors.purple[500], color: colors.gray[50] }}
										/>
									))
								) : (
									<ContrastChip
										title="Nenhum campo selecionado"
										backgroundColor={colors.gray[100]}
									/>
								)}
							</Grid>
						</Grid>
					</CustomFieldSelectionEditor>
				</BlockBodySection>
			</BlockBodySectionGroup>

			<BlockBodySectionGroup>
				<AfterActionConditionSection
					nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				/>
			</BlockBodySectionGroup>

			<WithoutAICreditsConditionSection
				nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				text="Se os créditos de IA acabarem"
			/>

			<NoFieldFilledConditionSection
				nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				text="Se nenhum campo for preenchido"
			/>
		</BaseBlock>
	)
}

export default CustomFieldFillBlock
